import { ColumnFilter } from './ColumnFilter.js'
import moment from 'moment'

export const ColumnNames = [
    {
        Header: 'id',
        accessor: 'id',
        Filter: ColumnFilter,

    },
    
    {
        Header: 'First Name',
        accessor: 'first_name',
        Filter: ColumnFilter,

    },
    
    {
        Header: 'Last Name',
        accessor: 'last_name',
        Filter: ColumnFilter
        
    },
    
   
    {
        Header: 'Invoice ID',
        accessor: 'invoice_id',
        Filter: ColumnFilter
        
    },
    {
        Header: 'Start Date',
        accessor: 'start_date',
        Cell: ({value})=>{ if (value === null) {return ''} else{return moment.utc(value).format('YYYY-MM-DD').toString()} },
        Filter: ColumnFilter,
    },
    {
        Header: 'Client',
        accessor: (row)=>{
            
            if (row.client_name === null){
                return row.client
            }else{
                return row.client_name
            }

        },
        
        Filter: ColumnFilter,
    },
    { 
        Header: 'Recruiter',
        accessor: 'rec_name',
    },
    { 
        Header: 'Account Manager',
        accessor: 'acc_name',
    },
    { 
        Header: 'Sourcer',
        accessor: 'sourc_name',
    },
    { 
        Header: 'Sales',
        accessor: 'sales_name',
    },

    {
        Header:()=>null,
        id: 'edit',
        Filter: ColumnFilter,
    },
]